import { Link } from 'react-router-dom';

export default function TermsScreen() {
  return (
    <div className="legal">
      <div className="legal__inner">
        <Link to="/" className="legal__back">← ScanRemind</Link>
        <h1>Terms of Service</h1>
        <p className="legal__updated">Last updated: May 22, 2026</p>

        <p>
          These terms apply when you use ScanRemind ("the service"), provided by Vital Integrators LLC
          ("we," "us"). By using the service, you agree to these terms. If you don't agree, please don't use it.
        </p>

        <h2>What you can use ScanRemind for</h2>
        <p>
          You can use ScanRemind to scan documents you have a legitimate right to read and to write
          events or contacts to your own Microsoft 365 account. Don't use it to:
        </p>
        <ul>
          <li>Scan documents you don't have permission to read</li>
          <li>Try to abuse, overload, or attack our infrastructure</li>
          <li>Reverse-engineer, scrape, or automate the service in ways that bypass normal use</li>
          <li>Resell or repackage the service</li>
        </ul>

        <h2>Your Microsoft account</h2>
        <p>
          You're responsible for the Microsoft account you connect. Calendar events and contacts created
          via ScanRemind live in your Microsoft 365 tenant and are subject to your Microsoft license terms.
          We don't have access to your Microsoft password and never see your data outside of what you
          explicitly scan.
        </p>

        <h2>AI accuracy</h2>
        <p>
          ScanRemind uses AI to read images. AI makes mistakes. Always review the extracted information
          on the confirmation screen before saving it to your calendar or contacts. We're not responsible
          for missed appointments or incorrect data resulting from AI extraction errors — that's why we
          show you the editable preview before anything is written.
        </p>

        <h2>Service availability</h2>
        <p>
          We aim for the service to be available, but it's offered "as is" without uptime guarantees.
          We may add features, change behavior, or take the service offline. We'll do our best to
          give notice of major changes via the home page.
        </p>

        <h2>Cost</h2>
        <p>
          ScanRemind is currently free during early access. We may introduce paid tiers in the future;
          if we do, existing free usage will not be retroactively charged.
        </p>

        <h2>Liability</h2>
        <p>
          To the extent allowed by law, our liability for any claim related to the service is limited
          to the amount you paid us in the previous 12 months (currently $0). We're not liable for
          indirect, consequential, or incidental damages — missed appointments, lost contacts, etc.
        </p>

        <h2>Termination</h2>
        <p>
          You can stop using ScanRemind any time by closing the browser. We may suspend access for
          accounts that violate these terms.
        </p>

        <h2>Changes</h2>
        <p>
          If we change these terms, we'll update the date above. Continued use after changes means you
          accept the new terms.
        </p>

        <h2>Governing law</h2>
        <p>
          These terms are governed by the laws of the State of Louisiana, USA. Any disputes will be
          resolved in the courts of Lafayette Parish, Louisiana.
        </p>

        <h2>Contact</h2>
        <p>
          Questions? Email <a href="mailto:support@vitalintegrators.com">support@vitalintegrators.com</a>.
        </p>

        <p style={{ marginTop: 48 }}>
          <Link to="/">← Back to ScanRemind</Link>
        </p>
      </div>
    </div>
  );
}
